import { render, staticRenderFns } from "./PlanService.vue?vue&type=template&id=3160cc2c&scoped=true&"
import script from "./PlanService.vue?vue&type=script&lang=js&"
export * from "./PlanService.vue?vue&type=script&lang=js&"
import style0 from "./PlanService.vue?vue&type=style&index=0&id=3160cc2c&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3160cc2c",
  null
  
)

export default component.exports